import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { chatService } from '@/services/chat';

export function useChatSentenceList() {
    const { list, total, fetchList } = useBaseListView({ request: chatService.sentence.list });

    const remove = useCrudActions().confirmAndRemove({
        request: chatService.sentence.remove,
        onSuccess: () => fetchList()
    });

    return { list, total, fetchList, remove };
}
